import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { API_PATH } from '../Constant/constants';
import { FaPrint, FaEye } from 'react-icons/fa';
import { Modal, Button } from 'react-bootstrap';

const InvoiceListPage = () => {
  const [invoices, setInvoices] = useState([]);
  const [selectedInvoice, setSelectedInvoice] = useState(null);
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    fetchInvoices();
  }, []);

  const fetchInvoices = async () => {
    try {
      const response = await axios.get(`${API_PATH}/billing`);
      setInvoices(response.data);
    } catch (err) {
      console.error('Error fetching invoices:', err);
    }
  };

  const handleView = (invoice) => {
    setSelectedInvoice(invoice);
    setShowModal(true);
  };

  const handlePrint = () => {
    window.print();
  };

  return (
    <div className="container py-4">
      <h4 className="mb-4">Invoice List</h4>
      <div className="table-responsive">
        <table className=" table-hover">
          <thead className="tableborder">
            <tr>
              <th>Invoice</th>
              <th>Name</th>
              <th>Phone</th>
              <th>Amount</th>
              <th>Generate (Dt.)</th>
              <th>Status</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {invoices.map((inv, idx) => (
              <tr key={idx} className='datahover'>
                <td>#{inv.invoiceNumber}</td>
                <td>{inv.patientName}</td>
                <td>{inv.phoneNumber}</td>
                <td>${inv.totalAmount}</td>
                <td>{new Date(inv.generatedAt).toLocaleDateString()}</td>
                <td>
                  <span className={`badge ${inv.status === 'Paid' ? 'bg-success' : 'bg-danger'}`}>
                    {inv.status}
                  </span>
                </td>
                <td>
                  <button className="btn btn-sm btn-outline-info me-2" onClick={() => handleView(inv)}>
                    <FaEye /> View
                  </button>
                  <button className="btn btn-sm btn-outline-primary" onClick={handlePrint}>
                    <FaPrint /> Print
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {selectedInvoice && (
        <Modal show={showModal} onHide={() => setShowModal(false)} size="lg">
          <Modal.Header closeButton>
            <Modal.Title>Patient Invoice</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="p-3">
              <h5>Doctris</h5>
              <p>Address: 1419 Riverwood Drive, Redding, CA 96001</p>
              <hr />
              <p><strong>Patient:</strong> {selectedInvoice.patientName}</p>
              <p><strong>Doctor:</strong> {selectedInvoice.doctorName}</p>
              <p><strong>Issue Date:</strong> {new Date(selectedInvoice.generatedAt).toLocaleDateString()}</p>
              <p><strong>Status:</strong> <span className={`badge ${selectedInvoice.status === 'Paid' ? 'bg-success' : 'bg-danger'}`}>{selectedInvoice.status}</span></p>
              <table className="table table-sm">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Item</th>
                    <th>Qty</th>
                    <th>Rate</th>
                    <th>Total</th>
                  </tr>
                </thead>
                <tbody>
                  {selectedInvoice.items.map((item, index) => (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>{item.name}</td>
                      <td>{item.qty}</td>
                      <td>${item.rate}</td>
                      <td>${item.qty * item.rate}</td>
                    </tr>
                  ))}
                  <tr>
                    <td colSpan="4" className="text-end"><strong>Total</strong></td>
                    <td><strong>${selectedInvoice.totalAmount}</strong></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowModal(false)}>
              Close
            </Button>
            <Button variant="primary" onClick={handlePrint}>
              <FaPrint /> Print
            </Button>
          </Modal.Footer>
        </Modal>
      )}
    </div>
  );
};

export default InvoiceListPage;
